class CollectionDescription extends HTMLElement {
  constructor() {
    super(),
      this.readMoreButtons = document.querySelectorAll(".collection-hero__description-action span"),
      this.buttonMore = document.querySelector(".btn--show-more"),
      this.buttonLess = document.querySelector(".btn--show-less"),
      this.content = document.querySelector(".collection-hero__content"),
      this.text = document.querySelector(".collection-hero__content"),
      this.readMoreButtons.forEach(button => {
          button.addEventListener("click", () => {
              this.content.classList.toggle("collection-hero__content--extended"),
                this.content.classList.contains("collection-hero__content--extended") ? (this.buttonMore.style.display = "none",
                  this.buttonLess.style.display = "block") : (this.buttonMore.style.display = "block",
                  this.buttonLess.style.display = "none")
            }
          )
        }
      ),
      this.updateButtonVisibility(),
      window.addEventListener("resize", () => {
          this.updateButtonVisibility()
        }
      )
  }
  updateButtonVisibility = () => {
    this.text.scrollHeight <= this.content.offsetHeight &&
    document.querySelector('.collection-hero__description-action').classList.add('hidden');
  }
}
customElements.define("collection-description", CollectionDescription);